"use strict";

var purinaBase = require("purina_core/product/base");
var baseDetail = require("base/product/detail");

baseDetail.sizeAttribute = function () {
    $(document).on("click", "[data-attr=\"size\"] button", function (e) {
        e.preventDefault();

        if ($(this).attr("disabled")) {
            return;
        }
        var $productContainer = $(this).closest(".set-item");
        if (!$productContainer.length) {
            $productContainer = $(this).closest(".product-detail");
        }

        purinaBase.attributeSelect($(this).attr("data-url"), $productContainer);

        var $availabilityMSG = $(this).closest(".set-product-attributes").find(".availability-msg");
        if ($(this).hasClass("unselectable")) {
            $availabilityMSG.addClass("not-available");
        } else {
            $availabilityMSG.removeClass("not-available");
        }
    });

    $(".description-and-detail table").css("width", "100%");
    $(".description-and-detail table").css("overflow-x", "auto");
    $(".description-and-detail td").css("word-break", "break-word");
    $(".description-and-detail table [style*=\"font-size\"]").css("font-size", "");
    $(".description-and-detail table [style*=\"font-family\"]").css("font-family", "");
    $(".description-and-detail table [style*=\"font-weight\"]").css("font-weight", "");
    $(".description-and-detail table [style*=\"font-style\"]").css("font-style", "");
    $(".description-and-detail table [style*=\"text-decoration\"]").css("text-decoration", "");
    $(".description-and-detail table [style*=\"color\"]").css("color", "");
    $(".description-and-detail table td [style*=\"width\"]").css("width", "100%");

};
baseDetail.initImageCarousel = function () {
    const Swiper = require("swiper").default;

    // initialize swiper for PDP images
    const swiper = new Swiper(".swiper-container", {
        direction: "horizontal",
        slidesPerView: 3,
        freeMode: true,
        loop: false,
        spaceBetween: 10,
        breakpoints: {
            768: {
                slidesPerView: 3
            },
            576: {
                slidesPerView: 2
            }
        }
    });

    // update product slider
    $(".product-details-slider").carousel({
        interval: false
    });
};

baseDetail.updateAttributesAndDetails = function () {
    $("body").on("product:statusUpdate", function (e, data) {
        var $productContainer = $(".product-detail[data-pid=\"" + data.id + "\"]");

        $productContainer.find(".description-and-detail .product-attributes")
            .empty()
            .html(data.attributesHtml);

        if (data.shortDescription) {
            $productContainer.find(".description-and-detail .description .content")
                .empty()
                .html(data.shortDescription);
        }

        if (data.longDescription) {
            $productContainer.find(".description-and-detail .details .content")
                .empty()
                .html(data.longDescription);
        }
    });
};

module.exports = baseDetail;


